import { accept } from './event.js';

/**
 * In macos, pressing ctrl+n increments to the next item in a list
 * ctrl+p moves to the previous item in a list
 * if matching event is found increment/decrement the index and swallow the event
 */
function makeHandleCtrlNav(setActiveIndex, options) {
    return function (listLength, activeIndex, e) {
        if (e.key === 'n' && e.ctrlKey) {
            if (activeIndex === null)
                setActiveIndex(0);
            else if (listLength - 1 !== activeIndex)
                setActiveIndex(activeIndex + 1);
            accept(e);
        }
        else if (e.key === 'p' && e.ctrlKey) {
            if (activeIndex === null)
                setActiveIndex(0);
            else if (activeIndex !== 0)
                setActiveIndex(activeIndex - 1);
            accept(e);
        }
        else if (e.key === 'ArrowDown' && e.altKey) {
            if (activeIndex === null)
                setActiveIndex(0);
            if (listLength - 1 !== activeIndex)
                setActiveIndex(listLength - 1);
            accept(e);
        }
        else if (e.key === 'ArrowUp' && e.altKey) {
            if ((activeIndex === null || activeIndex === 0) && options?.closeDropdown) {
                options.closeDropdown();
            }
            else {
                setActiveIndex(0);
            }
            accept(e);
        }
    };
}

export { makeHandleCtrlNav };
//# sourceMappingURL=ctrl-nav.js.map
